import React, {useState, useEffect, useRef} from 'react'
import AmbientBackground from './ambientBackground'
import classes from './VideoCarouselItem.module.scss'
import { getFileName } from '../../../../../helpers/FileCaching';
import ProgressBar from './ProgressBar';

const introductionImages = require.context('../../../../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);


function VideoCarouselItem({content, isActive, onTimeoutComplete, shouldPreload, onPlayPress, timeoutLengthSeconds, videoCdnUrl}){
	
	let [shouldShow, setShouldShow] = useState(false)
	let shouldShowTimeout = useRef()

	useEffect(() =>{
		if(isActive){
			setShouldShow(true)
			clearTimeout(shouldShowTimeout.current)
		}else{
			shouldShowTimeout.current = setTimeout(() => {
				setShouldShow(false)
			}, 3000);
		}
	}, [isActive])

	return (
		<section style={{display:(shouldShow ? "block" : "none")}} data-preload={`${shouldPreload}`} className={`${classes.VideoCarouselItem__wrapper} ${(isActive ? classes['VideoCarouselItem__wrapper--active'] : "")}`}>
			<AmbientBackground shouldPreload={shouldPreload} isActive={isActive} content={content.ambient} videoCdnUrl={videoCdnUrl}/>
			<div className={`${classes.VideoCarouselItem__progressBarWrap}`}>
				<ProgressBar timeoutLengthSeconds={timeoutLengthSeconds} isActive={isActive} timeoutComplete={onTimeoutComplete}/>
			</div>
			<div className={`${classes.VideoCarouselItem__contentContainer}`}>
				<div className={`${classes.VideoCarouselItem__titleContentContainer}`}>
					<div className={`${classes.VideoCarouselItem__titleContent}`}>
						<p className='subtitle_white_global'>Watch now</p>
						<h1 dangerouslySetInnerHTML={{__html:content.title}}/>
					</div>
					<div onClick={() => {onPlayPress()}} className={`${classes.VideoCarouselItem__playButton}`} 
					style={
						{
							backgroundImage: `url(${getFileName(introductionImages, 'playBtnWhite.svg')})`
						}
					}
					>
					</div>
				</div>
				<div className={`divider_white`}></div>
				<p className={`${classes.VideoCarouselItem__desc}`} dangerouslySetInnerHTML={{__html:content.description}}></p>
			</div>
        </section>
	)
}

export default VideoCarouselItem